import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74b9111b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "enter__name",
  style: {"position":"relative","width":"100%"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["id", "placeholder"]
const _hoisted_4 = {
  key: 2,
  class: "asterisk",
  style: {"position":"absolute","top":"-3px","color":"red"}
}

import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { Ref, ref, computed, onMounted, reactive, watch } from "vue";
import WizardDetailWrapper from "./wizardDetailWrapper.vue";
import MoreDetails from "./moreDetails.vue";
import { idWizardPage as idPage, statusPage } from "@/utils/constants";
import {
  IsSpecialCharDomainValid,
  getComponentUiText,
} from "@/utils/utilities";
import store from "@/store";
import { tlDomain } from "@/utils/validationRules";
import debounce from "lodash.debounce";

export default /*#__PURE__*/_defineComponent({
  __name: 'listDomain',
  props: {
  item: {
    type: Object,
    required: true,
  },
  currentIndex: {
    type: Number,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
},
  emits: ["changeStatusAddDomain"],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;

const isMoreDetails = ref(false);
const currentOrg = computed(() => store.state.Org.currentOrg);

const item = ref(props.data.item);
watch(
  () => props.data.item,
  (newValue) => {
    item.value = props.data.item;
  },
  { immediate: true },
);
const bodyAPIError = computed(() => {
  if (
    !item.value.id &&
    props.statusInPage.dataError.length > 0 &&
    item.value.isCallAPI
  ) {
    return true;
  }
  return (
    item.value.id &&
    props.statusInPage.dataError.find((i) => i.id === item.value.id)
  );
});
const statusInPageClone = ref(bodyAPIError);
const isFocus: Ref<boolean> = ref(false);
const rules = {
  domainName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-base-input-email-invalid-special-domain-characters-1",
        ),
      IsSpecialCharDomainValid,
    ),
    domain: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-domain-add-modal-domain-invalid-error-message-1",
        ),
      tlDomain,
    ),
  },
};

const v$ = useVuelidate(rules, item as any);
const saveChanges = async () => {
  await v$.value.$validate();
  // true is not error
  return !v$.value.$error;
};
__expose({
  saveChanges,
});

const debouncedUpdate = debounce((e) => {
  item.value.domainName = e;
  statusInPageClone.value && delete statusInPageClone.value.name;
  statusInPageClone.value && delete statusInPageClone.value.id;
  store.commit("SetupWizard/SET_DOMAIN_NAME", {
    value: { ...item.value, isCallAPI: false },
    _index: props.currentIndex,
    currentOrg: currentOrg.value.id,
  });
  emits("changeStatusAddDomain", true);
}, 300);
const updateStore = (e) => {
  debouncedUpdate(e.target.value);
};

const onBlurs = () => {
  isFocus.value = false;
};

const onFocus = () => {
  isFocus.value = true;
};

onMounted(() => {
  const input = document.querySelector(".enter__name") as HTMLInputElement;
  const asterisks = document.querySelectorAll(".asterisk");

  if (input && asterisks.length) {
    adjustAsteriskPosition();
  }

  // Function declarations
  function adjustAsteriskPosition() {
    const placeholderWidth = getTextWidth(
      getComponentUiText(
        "app-menu-submenu-home-setup-wizard-modal-domain-placeholder-input-1",
      ),
      getComputedStyle(input).font,
    );
    asterisks.forEach((asterisk) => {
      const ele = asterisk as HTMLElement;
      if (ele) {
        ele.style.left = `${placeholderWidth + 5}px`;
      }
    });
  }

  function getTextWidth(text, font) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (context) {
      context.font = font;
    }
    return context ? context.measureText(text).width : 0;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(WizardDetailWrapper, {
      class: _normalizeClass(['tw-mb-[25px]']),
      title: item.value.title,
      "show-accordion": item.value.showAccordion,
      "is-verified": item.value.isVerifiedDns,
      "is-verified-email": item.value.isVerifiedEmail,
      "is-show-tag-verified": true,
      data: __props.data,
      "page-active": _unref(idPage).domainPage,
      "show-question": false,
      validation: _unref(v$).domainName,
      "show-validate-now": true,
      "is-focus": isFocus.value,
      "is-api-error": statusInPageClone.value
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (item.value.domainName && !item.value.isEdit)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.value.domainName), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                id: `input-domain-${__props.data.index}`,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.domainName) = $event)),
                class: "enter__name",
                placeholder: 
              _unref(getComponentUiText)(
                'app-menu-submenu-home-setup-wizard-modal-domain-placeholder-input-1',
              )
            ,
                style: {"border":"unset","background-color":"unset"},
                onInput: updateStore,
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                onBlur: onBlurs,
                onFocus: onFocus
              }, null, 40, _hoisted_3)), [
                [_vModelText, item.value.domainName]
              ]),
          (!item.value.domainName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        (isMoreDetails.value)
          ? (_openBlock(), _createBlock(MoreDetails, {
              key: 0,
              "classes-more-detail": '!tw-p-0',
              "is-show-questions": false
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "show-accordion", "is-verified", "is-verified-email", "data", "page-active", "validation", "is-focus", "is-api-error"])
  ]))
}
}

})